import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';
const ToastContext = createContext(undefined);
export function useToast() {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
}
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const generateId = () => Math.random().toString(36).substring(2) + Date.now().toString(36);
    const addToast = (toast) => {
        const id = generateId();
        const newToast = { ...toast, id };
        setToasts(prev => [...prev, newToast]);
    };
    const removeToast = (id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };
    const showSuccess = (title, message, duration) => {
        addToast({ type: 'success', title, message, duration });
    };
    const showError = (title, message, duration) => {
        addToast({ type: 'error', title, message, duration: duration || 7000 }); // Errors stay longer
    };
    const showWarning = (title, message, duration) => {
        addToast({ type: 'warning', title, message, duration });
    };
    const showInfo = (title, message, duration) => {
        addToast({ type: 'info', title, message, duration });
    };
    const showValidationErrors = (errors, duration) => {
        errors.forEach(error => {
            showError(error.Title, error.Message, duration);
        });
    };
    const clearAll = () => {
        setToasts([]);
    };
    const value = {
        toasts,
        addToast,
        removeToast,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        showValidationErrors,
        clearAll
    };
    return (_jsx(ToastContext.Provider, { value: value, children: children }));
}
